import React, { useState } from 'react';
import { SubHeaderTextTW } from '../../../../../../tailwindComponents/subHeaderText/SubHeaderTextTW';
import { SignerItem } from './SignerItem';
import { AddSignatoriesButton } from './AddSignatoriesButton';
import { ISignerResponse } from '../../../../../../types/signingAppointment/ISignerResponse';
import { SignerEditionModal } from '../../../EditDeleteSigner/SignerEditionModal';
import { CreateSignerModal } from '../../../CreateSigner/CreateSignerModal';
import { ISigningAppointmentEditFormData } from '../../../../../../types/signingAppointment/ISigningAppointmentEditFormData';
import { Show } from '../../../../../shared/Show';
import { useSelectAppointmentFromPathParam } from '../../../../../../utilities/order/scheduling/useSomeAppointmentFromParam';
import { determineCanEdit } from '../../../EditAppointment/util';

/*SIGNATORIES SECTION*/
export const SignatoriesList: React.FC<{
  onSaveEditions: (formData: ISigningAppointmentEditFormData) => Promise<void>;
}> = ({ onSaveEditions }) => {
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();

  const [signerToEdit, setSignerToEdit] = useState<ISignerResponse | undefined>(undefined);
  const [showAddSigner, setShowAddSigner] = useState(false);
  const onEditSignerClick = (signer: ISignerResponse) => {
    setSignerToEdit(signer);
  };
  const onAddSignerClick = () => {
    setShowAddSigner(true);
  };
  const onCloseAddSigner = () => {
    setShowAddSigner(false);
  };
  const onCloseEditSigner = () => {
    setSignerToEdit(undefined);
  };
  if (!appointmentFromPath) return null;
  return (
    <>
      <SignerEditionModal signerToEdit={signerToEdit} onClose={onCloseEditSigner} onSaveEditions={onSaveEditions} />
      <CreateSignerModal show={showAddSigner} onClose={onCloseAddSigner} onSaveEditions={onSaveEditions} />
      <section>
        <SubHeaderTextTW className={'mr-5'}>Attendees</SubHeaderTextTW>
        {(appointmentFromPath.signers ?? []).map((signer) => (
          <SignerItem
            key={signer.id}
            signer={signer}
            onEditSigner={onEditSignerClick}
            canEdit={determineCanEdit(appointmentFromPath)}
          />
        ))}
        <Show when={determineCanEdit(appointmentFromPath)}>
          <AddSignatoriesButton onAddSignatoriesClick={onAddSignerClick} />
        </Show>
      </section>
    </>
  );
};
